import { FormControl, MenuItem, Select, styled } from "@mui/material";

export const FormControls = styled(FormControl)(({ theme }) => ({
  minWidth: "70px",
  width: "3%",
  backgroundColor: "#fff",
  borderRadius: "5px",
  border: "1px solid #fff",
  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)",
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#fff",
    },
    "&:hover fieldset": {
      borderColor: "#fff",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#fff",
      boxShadow: "none",
    },
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));
export const Selects = styled(Select)(() => ({
  fontSize: "12px",
  "& .MuiSelect-select": {
    paddingTop: "4px",
    paddingBottom: "4px",
    paddingRight: "12px",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "transparent",
  },
}));

export const MenuItems = styled(MenuItem)(() => ({
  fontSize: "12px",
}));
